import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchContextsArgs, SearchContextsOutput } from "types/generated";

type SearchContextsData = {
  searchContexts: SearchContextsOutput;
};

export const SEARCH_CONTEXTS: TypedDocumentNode<SearchContextsData, QuerySearchContextsArgs> = gql`
  query SearchContexts($input: SearchInput!) {
    searchContexts(input: $input) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          description
          name
          labels
          createdAt
          id
          allowedActions
          plugin {
            id
            name
          }
          spaceDetails {
            name
            id
          }
          hasAttachedStacks
        }
      }
    }
  }
`;

export const GET_CONTEXT_ATTACHMENTS = gql`
  query GetContextAttachments($id: ID!) {
    context(id: $id) {
      id
      hasAttachedStacks
      attachedStacks {
        id
        stackId
        stackName
        isModule
      }
    }
  }
`;

export const DELETE_CONTEXT = gql`
  mutation DeleteContextForContextList($id: ID!, $force: Boolean) {
    contextDelete(id: $id, force: $force) {
      id
      name
    }
  }
`;

export const UPDATE_CONTEXT = gql`
  mutation UpdateContext(
    $id: ID!
    $name: String!
    $description: String
    $labels: [String!]
    $space: ID
  ) {
    contextUpdateV2(
      id: $id
      input: { name: $name, description: $description, labels: $labels, space: $space }
    ) {
      id
      name
    }
  }
`;
